import iconMixin from '../../mixins/iconMixin'

export default {
  mixins: [iconMixin],
  data: function () {
    return {
      viewBox: "0 0 24 24",
      rawSvgPath: '<path d="M7.681,9.871h8.639v4.258H7.681V9.871z"/>\n' +
        '<path d="M22.745,8.86h-0.6v6.279h0.6c0.692-0.001,1.254-0.563,1.255-1.255v-3.77C23.999,9.422,23.438,8.861,22.745,8.86z"/>\n' +
        '<path d="M19.795,6.059h-2.38v11.883h2.38c0.693,0,1.255-0.562,1.255-1.254V7.313C21.05,6.62,20.488,6.06,19.795,6.059z"/>\n' +
        '<path d="M2.95,7.313v9.374c0.001,0.692,0.563,1.254,1.255,1.254h2.38V6.059h-2.38C3.512,6.06,2.951,6.62,2.95,7.313z"/>\n' +
        '<path d="M0,10.115v3.77c0,0.692,0.562,1.254,1.255,1.255h0.599V8.86H1.255C0.562,8.861,0.001,9.423,0,10.115z"/>',
    }
  },
}